export default "__VITE_ASSET__BgdYwWp3__"